import { render, staticRenderFns } from "./DefaultBanner.vue?vue&type=template&id=f8238c20&scoped=true"
import script from "./DefaultBanner.vue?vue&type=script&lang=js"
export * from "./DefaultBanner.vue?vue&type=script&lang=js"
import style0 from "./DefaultBanner.vue?vue&type=style&index=0&id=f8238c20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8238c20",
  null
  
)

export default component.exports